<template>
	<div id="dorm_bottom2">
		<div class="main-value dorm_att">
			<div class="normal-header">宿舍楼考勤管理
				<div class="title_tab">
					<div class="legend-color greenbg"></div>归宿
					<div class="legend-color yellowbg" style="margin-left: 0.15rem;"></div>请假
					<div class="legend-color redbg" style="margin-left: 0.15rem;"></div>未归
				</div>
			</div>
			<div id="dorm_att"></div>
		</div>
	</div>
</template>

<script>
import HighCharts from 'highcharts';
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var buildIds = storage.getItem("buildIds");
export default {
	data() {
		return {
			optionData: [],
			config: {
				time: '00:00:00', // 每天几点执行
				interval: 1, // 隔几天执行一次
				runNow: true, // 是否立即执行
				intervalTimer: '',
				timeOutTimer: ''
			}
		}
	},
	mounted() {
		this.initData();
		this.createTimer();
	},
	beforeDestroy() {
		console.log(
			'关闭任务定时器',
			this.config.intervalTimer
		)
		clearInterval(this.config.intervalTimer)
		console.log('清除定时器timeout', this.config.timeOutTimer)
		clearTimeout(this.config.timeOutTimer)
	},
	methods: {
		createTimer() {
			if (this.config.runNow) {
				this.runTimer()		// 如果配置了立刻运行则立刻运行任务函数
			}
			// 获取下次要执行的时间，如果执行时间已经过了今天，就让把执行时间设到明天的按时执行的时间
			var nowTime = new Date().getTime()
			var timePoint = this.config.time.split(':').map((i) => parseInt(i))
			var recent = new Date().setHours(...timePoint) // 获取执行时间的时间戳
			if (recent <= nowTime) {
				recent += 24 * 60 * 60 * 1000
			}
			// 未来程序执行的时间减去现在的时间，就是程序要多少秒之后执行
			var doRunTime = recent - nowTime
			this.config.timeOutTimer = setTimeout(this.setTimer, doRunTime)
		},
		setTimer() {
			console.log('进入定时器')
			this.runTimer()
			// 每隔多少天再执行一次
			var intTime = this.config.interval * 24 * 60 * 60 * 1000
			this.config.intervalTimer = setInterval(this.runTimer, intTime)
		},
		runTimer() {
			console.log("正在执行定时任务.......ing.....")
			this.initData();
		},
		initData() {
			//构建3d饼状图
			this.$http.get("/dataView/dorm/yesterdayCensus?orgId=" + orgId + "&buildIds=" + buildIds).then(res => {
				if (res.data.code === 200) {
					var falg = false;
					var dataParam = [];
					if (res.data.result.zs_count == 0 && res.data.result.qj_count == 0 && res.data.result.wg_count == 0) {
						falg = true;
						dataParam = [
							{ name: '归宿', sliced: false, color: '#00d587', y: 1 },
							{ name: '请假', sliced: false, color: '#e7d808', y: 1 },
							{ name: '未归', sliced: false, color: '#ff5959', y: 1 }
						];
					} else {
						dataParam = [
							{ name: '归宿', sliced: false, color: '#00d587', y: res.data.result.zs_count },
							{ name: '请假', sliced: false, color: '#e7d808', y: res.data.result.qj_count },
							{ name: '未归', sliced: false, color: '#ff5959', y: res.data.result.wg_count }
						];
					}
					var option = {
						chart: {
							type: "pie", //饼图
							options3d: {
								enabled: true, //使用3d功能
								alpha: 55, //延y轴向内的倾斜角度
								beta: 0,
							},
							animation: false,
							backgroundColor: 'rgba(255, 255, 255, 0)'
						},
						title: false,
						subtitle: false,
						credits: {
							enabled: false //不显示LOGO 
						},
						tooltip: {
							formatter: function () {
								if (falg) {
									return this.point.name + "<br>" + this.series.name + " : " + (this.point.y - 1);
								} else {
									return this.point.name + "<br>" + this.series.name + " : " + this.point.y;
								}
							}
						},
						plotOptions: {
							pie: {
								allowPointSelect: true, //每个扇块能否选中
								cursor: "pointer", //鼠标指针
								depth: 35, //饼图的厚度
								dataLabels: {
									enabled: true, //是否显示饼图的线形tip
									distance: '10',
									formatter: function () {
										if (falg) {
											return this.point.name + ":" + (this.point.y - 1);
										} else {
											return this.point.name + ":" + this.point.y;
										}
									},
									style: {
										color: '#fff',
										fontSize: "15px",
										fontWeight: '600',
										textOutline: "none", // 去除黑色阴影
									}
								}
							}
						},
						series: [{
							type: "pie",
							name: '人数',
							innerSize: '60%',
							data: dataParam
						}]
					}
					HighCharts.chart('dorm_att', option)
				}
			});
		},
	}
}
</script>
<style lang="scss">
#dorm_bottom2 {
	height: 100%;

	.water-eval-container {
		width: 100%;
		height: 100%;
	}

	padding-left:2%;

	.dorm_att {
		padding: 0.3rem 0 0 0.4rem;

		.title_tab {
			position: absolute;
			right: 0.5rem;
			font-size: 0.2rem;
			height: 0.15rem;
			line-height: 0.15rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.18rem;
				height: 0.18rem;
				border-radius: 50%;
				margin-right: 0.05rem;
			}
		}
	}

	#dorm_att {
		width: 93%;
		height: 90%;
	}

	@media screen and (min-width: 768px) and (max-width: 992px) {}

	@media screen and (min-width: 1200px) and (max-width: 1920px) {}
}
</style>
